import NoData from "@/components/NoData";
import LtdLoading from "@/components/LichThiDauFull/LtdLoading";
import useLichThiDauByCountry from "@/components/LichThiDauByCountry/useLichThiDauByCountry";
import CountryLeagueFilter from "@/components/LichThiDauByCountry/CountryLeagueFilter";
import MatchList from "@/components/LichThiDauByLeagueSidebar/MatchList";
import { getDateGroupLabel } from "@/utils/leagueFixturesByLeague";
import "@/components/LichThiDauFull/index.css";
import "@/components/LichThiDauByLeagueSidebar/index.css";

const DAYS = 30;

const TITLES = {
  tatca: "Lịch thi đấu",
  ketqua: "Kết quả thi đấu",
};

/**
 * @param {object} props
 * @param {string} props.country
 * @param {'tatca'|'ketqua'} [props.type]
 */
export default function LichThiDauByCountrySidebar({
  country: countrySlug,
  type = "tatca",
}) {
  const {
    themeStyle,
    leagues,
    selectedId,
    setSelectedId,
    activeLeagues,
    fixturesMap,
    waiting,
    failed,
    countryLoading,
  } = useLichThiDauByCountry(countrySlug, type, { days: DAYS });

  const league = activeLeagues[0] || null;
  const initialMatchesEntries = league
    ? fixturesMap[String(league.id)] || []
    : [];
  const title = TITLES[type] || TITLES.tatca;

  return (
    <div className="kbv-ltd-full kbv-ltd-sb" style={themeStyle}>
      <h2 className="kbv-bycountry-sb-title">{title}</h2>
      <div className="kbv-ltd-sb-filters">
        <CountryLeagueFilter
          compact
          leagues={leagues}
          selectedId={selectedId}
          onSelect={setSelectedId}
          themeStyle={themeStyle}
          loading={countryLoading}
        />
      </div>
      <div className="kbv-bycountry-scroll">
        {failed ? (
          <NoData message="Không tìm thấy quốc gia" />
        ) : !selectedId || waiting ? (
          <LtdLoading compact />
        ) : (
          <MatchList
            key={league?.id}
            league={league}
            initialMatchesEntries={initialMatchesEntries}
            themeStyle={themeStyle}
            showRoundSelect={false}
            getGroupLabel={(dateKey) => getDateGroupLabel(dateKey)}
          />
        )}
      </div>
    </div>
  );
}
